<div class="header">
  <div class="main-title">
    <app-svg-icon *ngIf="withIcon" class="logo" [path]="'/assets/logo.svg'"></app-svg-icon>
    <span>{{title}}</span>
    <app-progress *ngIf="progressIsVisible && title" class="progress" [progress]="progress"type="linear"></app-progress>
  </div>
  <app-progress *ngIf="progressIsVisible && !title" class="progress" [progress]="progress"type="linear"></app-progress>
  <button type="button" class="menu" (click)="openMenu($event)">
    <img src="/assets/hamburger_menu.svg" alt="=">
  </button>
</div>
<app-right-side-menu></app-right-side-menu>
